// extracted by mini-css-extract-plugin
export var orderSummary = "_tt-0";
export var showMoreLessButton = "_tt-1";